export default function initGA() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());

  const id = "G-Z2R40ZLHH2";
  // Queue config before route events, even while the external script is loading.
  // Gatsby owns initial and subsequent pageviews; history measurement is off in GA4.
  gtag("config", id, { anonymize_ip: true, send_page_view: false });

  const s = document.createElement("script");
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  s.async = true;
  document.head.appendChild(s);
}
